module.exports = __webpack_public_path__ + "img/aio_cover_d.1c76f209.png";